import { Box, theme } from "@aksara-ui/react";
import React from "react";
import Sidebar from "./Sidebar/Sidebar";
import Navbar from "./Navbar/Navbar";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";

interface Props {
  children: React.ReactNode;
}

const Layout: React.FC<Props> = ({ children }) => {
  const isTabletOrMobile = useMediaQuery({ maxWidth: 768 });
  const { isDrawerDesktopOpen } = useSelector(
    (state: any) => state.globalReducer
  );

  return (
    <Box display="flex" background={theme.colors.gray20}>
      <Sidebar />

      <Box width={"100%"} height={"100%"}>
        <Navbar
          paddigLeft={!isTabletOrMobile ? (isDrawerDesktopOpen ? 280 : 100) : 0}
        />
        <Box
          height={"100%"}
          style={{
            transition: "all 0.3s",
          }}
          marginTop={60}
          marginLeft={!isTabletOrMobile ? (isDrawerDesktopOpen ? 280 : 100) : 0}
          paddingBottom={!isTabletOrMobile ? 50 : 60}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
